import { inject, Injectable } from '@angular/core';
import { AuthSessionDto, ImpersonationsClient } from '@unity/clients';
import { SessionService } from '@unity/services/session.service';
import { take, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImpersonationService {
  private readonly impersonationsClient = inject(ImpersonationsClient);
  private readonly sessionService = inject(SessionService);

  private impersonate$(username: string, callback: (session: AuthSessionDto) => void) {
    return this.impersonationsClient.createOne({ username }).pipe(
      take(1),
      tap(session => callback(session))
    );
  }

  public startImpersonating(username: string) {
    this.impersonate$(username, (session: AuthSessionDto) => this.sessionService.handleImpersonationResponse(session)).subscribe();
  }

  public stopImpersonating() {
    this.sessionService.endImpersonation();
  }

  public switchImpersonationTo(username: string) {
    this.stopImpersonating();
    this.startImpersonating(username);
  }
}
